import { useTranslation } from 'react-i18next';
import { SearchX } from 'lucide-react';
import { type DebriefStage } from '@momentum/types';
import { AddFactSection } from './AddFactSection';

interface EmptyStagePlaceholderProps {
  stage: DebriefStage;
}

export function EmptyStagePlaceholder({ stage }: EmptyStagePlaceholderProps) {
  const { t } = useTranslation('debriefV2');

  return (
    <div className="border border-dashed border-slate-300 rounded-xl bg-slate-50/50 p-6 flex flex-col items-center justify-center text-center">
      <SearchX className="h-6 w-6 text-slate-400 mb-2" aria-hidden />
      <p className="text-sm font-medium text-slate-800 mb-1">
        {t('gather.emptyStage.title')}
      </p>
      <p className="text-xs text-slate-500">
        {t('gather.emptyStage.subtitle')}
      </p>
      <AddFactSection stage={stage} variant="empty-state" />
    </div>
  );
}
